@if (error$ | async; as error) {
  <div role="alert" class="alert alert-danger">
    {{ error | translate }}
    <button type="button" class="btn btn-outline-danger" (click)="retrySearch()">
      {{ 'POLYGON_RETRY' | translate }}
    </button>
  </div>
}
@let isArabic = isArabic$ | async;
@let carResults = carResults$ | async;
@let isMapView = isMapView$ | async;
<ul
  class="nav nav-tabs d-flex justify-content-center pt-3 border-primary"
  #mapToggle
  id="searchResultTabs"
  role="tablist"
  #listTop
>
  <li class="nav-item" role="presentation">
    <button
      class="nav-link"
      [ngClass]="isMapView ? '' : 'active'"
      id="list-tab"
      data-bs-toggle="tab"
      data-bs-target="#list-pane"
      type="button"
      role="tab"
      aria-controls="list-pane"
      aria-selected="true"
      (click)="setMapView(false)"
    >
      <i class="bi bi-grid-fill"></i>
      {{ 'LIST_VIEW' | translate }}
    </button>
  </li>

  <li class="nav-item" role="presentation">
    <button
      class="nav-link"
      [ngClass]="isMapView ? 'active' : ''"
      id="map-tab"
      data-bs-toggle="tab"
      data-bs-target="#map-pane"
      type="button"
      role="tab"
      (click)="setMapView(true)"
    >
      <i class="bi bi-map-fill"></i>
      {{ 'MAP_VIEW' | translate }}
    </button>
  </li>
</ul>

<div class="tab-content" id="searchResultTabsContent">
  <!-- LIST TAB -->
  <div
    class="tab-pane fade"
    [ngClass]="isMapView ? '' : 'active show'"
    id="list-pane"
    role="tabpanel"
    aria-labelledby="list-tab"
  >
    @if (carResults && carResults.total > 0) {
      <div class="row mt-4">
        <ng-container
          *ngTemplateOutlet="resultToolbar; context: { $implicit: carResults.total }"
        ></ng-container>

        @if (carResults.items != null) {
          <car-list [cars]="carResults.items"></car-list>
        }

        <!-- Pagination component -->
        <div class="col-12 mb-3">
          @if (
            carResults.total !== null &&
            carResults.total !== undefined &&
            carResults.total > carResults.pageSize
          ) {
            <nav>
              <ul class="pagination justify-content-center mb-0 px-0">
                <!-- First -->
                <li class="page-item" [class.disabled]="carResults.pageIndex === 0">
                  <button class="page-link p-1 px-2" aria-label="First" (click)="first()">
                    <i
                      class="bi small"
                      [ngClass]="isArabic ? 'bi-chevron-double-right' : 'bi-chevron-double-left'"
                    ></i>
                  </button>
                </li>

                <!-- Previous -->
                <li class="page-item" [class.disabled]="carResults.pageIndex === 0">
                  <button class="page-link p-1 px-2" (click)="goTo(carResults.pageIndex)">
                    <i
                      class="bi bi-chevron-left small"
                      [ngClass]="isArabic ? 'bi-chevron-right' : 'bi-chevron-left'"
                    ></i>
                  </button>
                </li>

                @if (visiblePages$ | async; as visiblePages) {
                  @for (page of visiblePages; track $index) {
                    @if (page === '...') {
                      <li class="page-item disabled">
                        <span class="page-link p-1 px-2">...</span>
                      </li>
                    } @else {
                      <li class="page-item" [class.active]="page === carResults.pageIndex + 1">
                        <button class="page-link p-1 px-2" (click)="goTo(+page)">
                          {{ page }}
                        </button>
                      </li>
                    }
                  }
                }

                <!-- Next -->
                <li class="page-item" [class.disabled]="isLastPage(carResults)">
                  <button class="page-link p-1 px-2" (click)="goTo(carResults.pageIndex + 2)">
                    <i
                      class="bi small"
                      [ngClass]="isArabic ? 'bi-chevron-left' : 'bi-chevron-right'"
                    ></i>
                  </button>
                </li>
                <!-- Last -->
                <li class="page-item" [class.disabled]="isLastPage(carResults)">
                  <button
                    class="page-link p-1 px-2"
                    (click)="last(carResults.total, carResults.pageSize)"
                  >
                    <i
                      class="bi small"
                      [ngClass]="isArabic ? 'bi-chevron-double-left' : 'bi-chevron-double-right'"
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          }
        </div>
      </div>
    } @else if (searchEmpty$ | async) {
      <div class="alert text-center mt-3 bg-primary text-dark">
        {{ 'NO_CAR_FOUND' | translate }}
      </div>
    }
  </div>

  <!-- MAP TAB -->
  <div
    class="tab-pane fade"
    [ngClass]="isMapView ? 'active show' : ''"
    id="map-pane"
    role="tabpanel"
    aria-labelledby="map-tab"
  >
    @let carMapResults = carMapResults$ | async;
    @let mapHistory = searchHistoryState();
    <app-map-result
      [loading]="(mapLoading$ | async) ?? false"
      [polygonEnabled]="true"
      [polygonRevision]="(polygonRevision$ | async) ?? 0"
      [activePolygon]="polygon$ | async"
      [searchError]="mapError$ | async"
      (polygonChanged)="applyPolygon($event)"
      [result]="carMapResults?.items ?? []"
      [mapParameters]="mapHistory?.mapQuery ?? mapParameters"
      searchDomain="CAR"
      [restoredViewport]="mapHistory?.mapViewport"
      [searchRestoreRevision]="mapHistory?.searchRestoreRevision ?? 0"
      icon="car"
      (mapChanged)="updateMap($event)"
    ></app-map-result>
    @if (carMapResults; as mapResult) {
      <section
        class="map-list-results row mt-4"
        aria-label="{{ 'MAP_RESULTS_HEADING' | translate }}"
      >
        <h2 class="col-12 h4">{{ 'MAP_RESULTS_HEADING' | translate }}</h2>
        <ng-container
          *ngTemplateOutlet="resultToolbar; context: { $implicit: mapResult.total }"
        ></ng-container>
        <car-list [cars]="visibleMapCards()" listId="carMapList"></car-list>
        @if (mapCards.loading()) { <app-loading [height]="70" theme="light" /> }
      @if (mapCards.error()) {
        <div role="alert" class="text-center">
          {{ 'POLYGON_SEARCH_FAILED' | translate }}
          <button type="button" class="btn btn-outline-primary" (click)="mapCards.retry()">{{ 'POLYGON_RETRY' | translate }}</button>
        </div>
      }
      @if (mapCardLimit() < mapListItems().length) {
          <div class="col-12 text-center mb-3">
            <button
              type="button"
              class="bg-black btn btn-outline-primary map-load-more"
              [disabled]="mapCards.loading()"
              (click)="loadMoreMapCards()"
            >
              {{ 'MAP_LOAD_MORE' | translate }}
            </button>
          </div>
        }
      </section>
    }
  </div>
</div>

<ng-template #resultToolbar let-total>
  <div
    class="col-12 mb-3 d-flex justify-content-between align-items-center"
    [ngClass]="isArabic ? 'text-end' : 'text-start'"
  >
    <!-- order component -->
    <div class="dropdown d-inline-block">
      <button
        class="btn btn-outline-dark d-flex align-items-center gap-2"
        type="button"
        data-bs-toggle="dropdown"
      >
        <i class="bi" [ngClass]="sortIcon"></i>
        <span class="fw-semibold">{{ sortLabel | translate }}</span>
      </button>

      <ul class="dropdown-menu dropdown-menu-end" [ngClass]="isArabic ? 'rtl-mode' : 'ltr-mode'">
        <li>
          <button
            class="dropdown-item"
            [class.active]="sortProperty === 'createdAt'"
            (click)="setSort('createdAt')"
          >
            {{ 'ORDER_BY_DATE' | translate }}
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            [class.active]="sortProperty === 'price'"
            (click)="setSort('price')"
          >
            {{ 'ORDER_BY_PRICE' | translate }}
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            [class.active]="sortProperty === 'kilometers'"
            (click)="setSort('kilometers')"
          >
            {{ 'ORDER_BY_KILOMETERS' | translate }}
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            [class.active]="sortProperty === 'performance'"
            (click)="setSort('performance')"
          >
            {{ 'ORDER_BY_PERFORMANCE' | translate }}
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            [class.active]="sortProperty === 'year'"
            (click)="setSort('year')"
          >
            {{ 'ORDER_BY_YEAR' | translate }}
          </button>
        </li>
      </ul>
    </div>

    <span class="text-dark fs-5 border-bottom border-primary border-dark"
      >{{ 'ADS' | translate }} {{ total }}
    </span>
  </div>
</ng-template>
